import { ExpedientesService } from './../../services/expedientes.service';
import { Router } from '@angular/router';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { AuthService } from '../../services/auth.service';

declare let paypal:any;
@Component({
  selector: 'app-consultas',
  templateUrl: './consultas.component.html',
  styleUrls: ['./consultas.component.css']
})
export class ConsultasComponent implements OnInit, AfterViewChecked {

  tipo;
  addScript:boolean=false;
  paypalLoad:boolean=false;
  paypalConfig:{};
  coste:number=0;
  finalAmount:number=0;
  servicio:string;
  descripcion:string;
  sku:string;
  iva:number=0.21;

  constructor(private auth:AuthService, private activatedRoute:ActivatedRoute, private router:Router,
  private expedientesService:ExpedientesService) {
    this.activatedRoute.params.subscribe(params=>{
      this.tipo=params["tipo"];
      
    });

    if(this.tipo=="consultalegal"){
      this.servicio="Consulta legal";
      this.coste=15;
      this.descripcion="Consulta Legal Web";
      this.sku="CL-"+this.expedientesService.expedienteActivo["EXcodigo"];

    }else if(this.tipo=="estudiolegal"){
      this.servicio="Estudio legal";
      this.coste=50;
      this.descripcion="Estudio Legal Web";
      this.sku="EL-"+this.expedientesService.expedienteActivo["EXcodigo"];
    
    }else if(this.tipo=="revisioncontrato"){
      this.servicio="Revisión de Contratos";
      this.coste=25;
      this.descripcion="Revisión de contrato";
      this.sku=this.expedientesService.ServicioLegalActivo['pedido'];
    
    }else if(this.tipo=="redaccioncontrato"){
      this.servicio="Redacción de Contratos";
      this.coste=50;
      this.descripcion= "Redaccion de contrato";
      this.sku=this.expedientesService.ServicioLegalActivo['pedido'];
    
    }else if(this.tipo=="burofaxlegal"){
      this.servicio="Servicio burofax legal";
      this.coste=70;
      this.descripcion="Servicio burofax legal";
      this.sku=this.expedientesService.ServicioLegalActivo['pedido'];
    
    }else if(this.tipo=="declaracionrenta"){
      this.servicio="Servicio declaración de renta";
      this.coste=40;
      this.descripcion="Servicio declaración de la renta";
      this.sku=this.expedientesService.ServicioLegalActivo['pedido'];
    
    }else{
      router.navigate(["/home"]);
    }

    this.finalAmount=this.coste*1.21;

  }

  ngOnInit() {
    
    if(this.tipo=="revisioncontrato" || this.tipo=="redaccioncontrato" || this.tipo=="burofaxlegal" || this.tipo=="declaracionrenta"){
      if(this.auth.loggedIn.value==true){
        this.auth.logout();
        window.top.location.href="https://solucionlegal.es";
      }else{
        this.paypalServicio();
      }
     
    }else if(this.tipo=="consultalegal" || this.tipo=="estudiolegal"){
      this.paypalConsulta();
      console.log(this.expedientesService.expedienteActivo);
    }else{
      this.router.navigate(["/home"]);
    }
    
  }

  paypalConsulta(){
    this.paypalConfig={
      env: 'production',
      client:{
        sandbox: 'AcFlPM25EaWlAljCEbL8pHdBpLN2eroTsngaRlgIFD_S-MJNFgPAo4JWnP1fEHz7xUb1DO4uCZynlwCl',
        production: 'AWsd51MYWrVIzFk0MrX_k67MMdYMfdTeTxSB5IPcvrQw-vXdhrq5Z58IiqXe3L4-0ea6VcMKAqnQE5py'
      },
      commit:true,
      payment: (data,actions)=>{
        return actions.payment.create({
          payment:{
            transactions: [
              {amount: {
                total: this.finalAmount,
                currency: 'EUR',
                details:{
                  subtotal:this.coste,
                  tax: this.coste*this.iva
                }
                },
                item_list: {
                  items: [
                    {
                    sku: this.sku,
                    description: this.descripcion,
                    quantity: 1,
                    price: this.coste,
                    currency: 'EUR'
                    }
                  ]
                }
              }
            ]
          },
          experience: {
                    input_fields: {
                        no_shipping: 1
                    }
                }
  
        });
      },
      onAuthorize: (data,actions)=>{
        return actions.payment.execute().then((payment)=>{
          //do something when payment is succesfull
          if(this.auth.loggedIn.value==true){
            this.expedientesService.pagarExpediente(this.expedientesService.expedienteActivo["EXcodigo"]).subscribe(resp=>{
              
              alert("Pago completado correctamente.");
              this.router.navigate(["/expedientes"]);
            });
          }else if(this.auth.loggedIn.value==false){
            this.expedientesService.pagarExpedienteWeb(this.expedientesService.expedienteActivo["EXcodigo"]).subscribe(resp=>{
              
              alert("Pago completado correctamente.");
              window.top.location.href="https://solucionlegal.es";
            });
          }
        });
      }
    }
  }

  paypalServicio(){

    this.paypalConfig={
      env: 'production',
      client:{
        sandbox: 'AcFlPM25EaWlAljCEbL8pHdBpLN2eroTsngaRlgIFD_S-MJNFgPAo4JWnP1fEHz7xUb1DO4uCZynlwCl',
        production: 'AWsd51MYWrVIzFk0MrX_k67MMdYMfdTeTxSB5IPcvrQw-vXdhrq5Z58IiqXe3L4-0ea6VcMKAqnQE5py'
      },
      commit:true,
      payment: (data,actions)=>{
        return actions.payment.create({
          payment:{
            transactions: [
              {amount: {
                total: this.finalAmount,
                currency: 'EUR',
                details:{
                  subtotal:this.coste,
                  tax: this.coste*this.iva
                }
                },
                item_list: {
                  items: [
                    {
                    description: this.descripcion,
                    quantity: 1,
                    price: this.coste,
                    currency: 'EUR'
                    }
                  ]
                }
              }
            ]
          },
          experience: {
                    input_fields: {
                        no_shipping: 1
                    }
                }
  
        });
      },
      onAuthorize: (data,actions)=>{
        return actions.payment.execute().then((payment)=>{
          //do something when payment is succesfull
          if(this.auth.loggedIn.value==false){
            this.expedientesService.ServicioLegalActivo["tipo"]=this.servicio;
            this.expedientesService.pagarServicioWeb().subscribe(resp=>{
              alert("pago completado correctamente");
              window.top.location.href="https://solucionlegal.es";
            });
          }else{
            window.top.location.href="https://solucionlegal.es";
          }
        });
      }
    }
  }

  ngAfterViewChecked(): void{
    if(!this.addScript){
      this.addPaypalScript().then(()=>{
        paypal.Button.render(this.paypalConfig, '#paypal-checkout-btn');
        this.paypalLoad=true;
      })
    }
  }

  addPaypalScript(){
    this.addScript=true;
    return new Promise((resolve, reject)=>{
      let scripttagElement= document.createElement('script');
      scripttagElement.src= 'https://www.paypalobjects.com/api/checkout.js';
      scripttagElement.onload=resolve;
      document.body.appendChild(scripttagElement);
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/consultas/consultas.component.ts